import firebase from 'firebase/app';
import "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyBSEDd05GUXTUxiWOKUaLm924yuC8ekVUg",
  authDomain: "thepantry-8276c.firebaseapp.com",
  projectId: "thepantry-8276c",
  storageBucket: "thepantry-8276c.appspot.com",
  messagingSenderId: "775061549511",
  appId: "1:775061549511:web:451a32c31f162ee95ee9e2",
  measurementId: "G-TK9YB9MLE3"
};

  firebase.initializeApp(firebaseConfig);

  const Storage = firebase.storage();

  export { Storage, firebase as default};